import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { environment } from '@env/environment';
import { AuthFacade } from './domain/facades';
import { ResetVersionProvider } from './data/providers';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private readonly authFacade = inject(AuthFacade);
  private readonly resetVersionService = inject(ResetVersionProvider);
  readonly title = 'sm-backoffice-sm';

  ngOnInit(): void {
    console.log(`..:: version: ${environment.version} ::..`);
    this.resetVersionService.validateVersion();
    this.authFacade.closeSessionTimer();
  }
}
